import React from 'react';
import { Switch } from 'react-router-dom';

import { PERMISSIONS, ROUTES } from '../../../constants';
import PrivateRoute from '../../../routes/PrivateRoute';
import { OrderProvider } from '../../order/hooks/order';
import { RouteProvider } from '../../route/hooks/route';
import { Dashboard } from '../pages/Dashboard';
import { ManagementDashboard } from '../pages/ManagementDashboard';

export const DashboardRoute: React.FC = () => (
  <OrderProvider>
    <RouteProvider>
      <Switch>
        <PrivateRoute
          path={ROUTES.managementDashboard}
          permission={PERMISSIONS.DASHBOARD_VIEW}
          component={ManagementDashboard}
        />
        <PrivateRoute
          path={ROUTES.dashboard}
          permission={PERMISSIONS.DASHBOARD_VIEW}
          component={Dashboard}
        />
      </Switch>
    </RouteProvider>
  </OrderProvider>
);
